<template>
<div  v-loading="loading" element-loading-text="数据导出中">
  <div class="op">
    <!-- <Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode> -->
<div class="nam">
  <el-input v-model="name" style="margin-left:10px" clearable size="mini" placeholder="请输入姓名"></el-input>
</div>
  <div class="idc">
  <el-input v-model="idcard" size="mini" clearable placeholder="请输入身份证号"></el-input>
</div>
 <!-- <div class="add">
  <el-select size="mini" @change="torz" clearable  v-model="state" placeholder="所有状态">
    <el-option
      v-for="item3 in stateList"
      :key="item3.value"
      :label="item3.label"
      :value="item3.value">
    </el-option>
  </el-select>
</div> -->
<!-- <div class="add">
    <el-date-picker
      v-model="time"
      size='mini'
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
</div> -->
   <div class="add"  style="margin-left:10px">
  <el-select size="mini"  v-model="socialSecurityType" clearable placeholder="参保类型">
    <el-option
      v-for="item6 in socialSecurityTypeList"
      :key="item6.value"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select>
</div>
<!-- <div class="add">
    <el-select size="mini" @change="torz" clearable v-model="age" placeholder="选择年龄">
    <el-option
      v-for="item4 in ageList"
      :key="item4.value"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-select size="mini" @change="torz" clearable v-model="agemeth" placeholder="年龄计算方式">
    <el-option
      v-for="item5 in agemethList"
      :key="item5.value"
      :label="item5.label"
      :value="item5.value">
    </el-option>
  </el-select>
</div> -->
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
</div>
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe>
    <el-table-column
      prop="idcard"
      label="身份证号"
      width="180">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="100">
    </el-table-column>
    <el-table-column
      prop="gender"
      label="性别"
      width="60">
    </el-table-column>
      <el-table-column
      prop="nation"
       width="80"
      label="民族">
    </el-table-column>
     <el-table-column
      prop="tel"
       width="110"
      label="手机号">
    </el-table-column>
      <el-table-column
      prop="socialSecurityType"
       width="180"
      label="参保类别">
    </el-table-column>
    <el-table-column
      prop="birthday"
      label="出生年月">
    </el-table-column>
     <el-table-column
      prop="educationLevel"
      label="文化程度">
    </el-table-column>
     <el-table-column
      prop="archivesAddress"
      label="档案存放地点">
    </el-table-column>
    <el-table-column
      prop="socialSecurityAddress"
      label="社会关系保险所在地">
    </el-table-column>
 <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button
          size="mini"
          @click="look(scope.$index, scope.row)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="rrr">
  <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
    <!-- <el-button type="success" size="mini" icon="el-icon-download" @click="toExcel()">导出</el-button> -->
     <kt-button class="changeBasic" icon="fa el-icon-download" label="导出" perms="auth:menu:down" type="primary" @click="toExcel" />
    </div>
  </div>
</template>

<style scoped>
.rrr{
  display: flex;
  margin: 20px;
  height: 30px;
  justify-content: space-around;
  align-items: center
}
.pone{
  margin: 0 !important
}
.el-cascader-menu__wrap{
  height: 404px !important
}
.op{
  display: flex;
  align-items: center;
}
  .idc{
    width: 200px
  }
  .nam{
    margin-right: 20px
  }
  .ywtyoe{
    width: 200px;
    margin-left: 20px
  }
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .el-timeline{
    padding-left: 20px
  }
  .add{
      margin-left: 20px
  }
</style>

<script>
import Axios from "axios"
import Cookies from "js-cookie";
import CryptoJS from 'crypto-js'
import { Loading } from 'element-ui';
import {listtown} from '../../utils/address'
import {baseUrl2} from "../../utils/global"
import defaultImg from "../../assets/defaultPicture.jpg"
import Candode from "../Core/candode"
import {decryptByDES,decrypt} from '../../utils/cypto'
import {formatDate} from '../../utils/datetime'
import {getType} from "../../utils/typeAuth"
import baseUrl from "../../utils/global"
import KtButton from "@/views/Core/KtButton"
import {fromModel} from "../../utils/fromModel"
import axios from "axios"
console.log(fromModel(1))
  export default {
    components:{
      Candode,
      KtButton
    },
       data() {
      return {
        loading:false,
        list:[],
        name:"",
        town:"",
        village:"",
        defaultImg: defaultImg,
        townList:[],
        imgUrl:"http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/",
        Page:1,
        totals:0,
        idcard:"",
        info:'',
        ywtype:'',
        tableData: [],
        list2:[],
        //认证状态
        state:"",
        stateList:[{
          value:"0",
          label:"认证成功",
        },{
          value:"2",
          label:"认证失败",
        },{
          value:"5",
          label:"未认证",
        },{
          value:"3",
          label:"审核中",
        }],
        //时间
        time:"",
        //年龄
        //年龄计算方式
        agemeth:"1",
        agemethList:[{
          value:"1",
          label:"按年计算",
        },{
          value:"2",
          label:"按月计算",
        }],
        //参保类型
        socialSecurityType:'',
        socialSecurityTypeList:[{
                label:"养老",
                value:'0'
            },{
                label:"医疗",
                value:'1'
            }],
        townlen:1
      }
    },
    methods: {
      fromModel:fromModel,
      strReplace(msg){
        let str=getType(msg)
        return str
      },
      formatDate:formatDate,
      childByValue(val){
        this.townList=val
      },
      getTownlength(val){
        this.townlen=val
      },
      //搜索
      serch(){
       this.serchTest(1)
      },
    
      toExcel(){
        let data={
        name:this.name,
        // province_name:this.townList[0]?this.townList[0].split(",")[0]:'',
        // city_name:this.townList[1]?this.townList[1].split(",")[0]:'',
        // county_name:this.townList[2]?this.townList[2].split(",")[0]:'',
        // town_name:this.townList[3]?this.townList[3].split(",")[0]:'',
        // village_name:this.townList[4]?this.townList[4].split(",")[0]:'',
        // province:this.townList[0]?this.townList[0].split(",")[1]:'',
        // city:this.townList[1]?this.townList[1].split(",")[1]:'',
        // county:this.townList[2]?this.townList[2].split(",")[1]:'',
        // town:this.townList[3]?this.townList[3].split(",")[1]:'',
        // village:this.townList[4]?this.townList[4].split(",")[1]:'',
        // birthday:this.age,
        idcard:this.idcard,
        //match_state:this.state,
        socialSecurityType:this.socialSecurityType,
        //verifyType:this.cblx,
        //start_time:this.time?this.formatDate(this.time[0]):'',
        //end_time:this.time?this.formatDate(this.time[1]):'',
        //quarry_rule :this.agemeth
     }
    
     axios.post(
      baseUrl.baseUrl+"/retiress/export/baseinfo",
      data,{
      responseType: 'blob',
      headers:{
        token:Cookies.get("token")
      }
      }
    ).then(res => {
        let blob = res.data
        let reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          let a = document.createElement('a')
          a.download = `移交地区数据.xlsx`
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
 }
})
      //  this.$api.getlist.exportbaseinfo(data).then((res) => {
      // var that=this
      // if(res.code==200){
			// 	this.loading=false
			// 			window.location.href=baseUrl.baseUrl+"/download/excel?fileName="+res.result
			// 		}else if(res.code==100){
      //       setTimeout(() => {
      //         this.toExcel()
      //       }, 5000);
      //     }else{
      //       this.loading=false
      //       this.$message(res.describe)
      //     }


      //   }).catch((res) => {
      //     this.$message("导出失败")
      //     	this.loading=false
      //   });
    
      },
      serchTest(s){
        Loading.service();
      var data={
        pageNum:s,
        pageSize:10,
        name:this.name,
        // province_name:this.townList[0]?this.townList[0].split(",")[0]:'',
        // city_name:this.townList[1]?this.townList[1].split(",")[0]:'',
        // county_name:this.townList[2]?this.townList[2].split(",")[0]:'',
        // town_name:this.townList[3]?this.townList[3].split(",")[0]:'',
        // village_name:this.townList[4]?this.townList[4].split(",")[0]:'',
        // province:this.townList[0]?this.townList[0].split(",")[1]:'',
        // city:this.townList[1]?this.townList[1].split(",")[1]:'',
        // county:this.townList[2]?this.townList[2].split(",")[1]:'',
        // town:this.townList[3]?this.townList[3].split(",")[1]:'',
        // village:this.townList[4]?this.townList[4].split(",")[1]:'',
        // birthday:this.age,
        idcard:this.idcard,
        //match_state:this.state,
        socialSecurityType:this.socialSecurityType,
        //verifyType:this.cblx,
        //start_time:this.time?this.formatDate(this.time[0]):'',
        //end_time:this.time?this.formatDate(this.time[1]):'',
        //quarry_rule :this.agemeth
       }
       this.$api.getlist.baseinfo(data)
  .then(res => {
       let result=res.data.list
        this.totals=res.data.total
      //  for(var i in result){
      //     result[i].identityNumber=this.decrypt(result[i].identityNumber)
      //     result[i].personName=this.decrypt(result[i].personName)
      //     result[i].telphone=result[i].telphone?this.decrypt(result[i].telphone):''
      //     result[i].createTime=result[i].createTime?this.formatDate(result[i].createTime):""
      //     result[i].verify_types=result[i].verify_types?this.strReplace(result[i].verify_types):''
      //     result[i].match_state=result[i].match_state==0?"认证成功":result[i].match_state==1?"认证未完成":result[i].match_state==2?'认证失败':result[i].match_state==3?'审核中':result[i].match_state==4?'停止发放':result[i].match_state==5?'已死亡':''
      //  }
         this.tableData=result
         let loadingInstance = Loading.service();
                this.$nextTick(() => { //以服务的方式调用的 Loading需要异步关闭
                loadingInstance.close();
              });
  })
  .catch(err => {
     let loadingInstance = Loading.service();
                this.$nextTick(() => { //以服务的方式调用的 Loading 需要异步关闭
                loadingInstance.close();
              });
  });
      },
      current_change(ss){
        this.serchTest(ss)
      },
     look(s,d){
       let data={
         id:d.id
       }
         this.$api.getlist.allinfo(data).then(res=>{
           if(res.code==200){
           sessionStorage.setItem("msginfo",JSON.stringify(res.data))
           this.$router.push({
             name:"详细信息"
           })
          }else{
            this.$message({
              type:"warning",
              message:res.message
            })
          }
         }).catch(err=>{

         })
       console.log(d)
     },
        Encrypt(word) { //aes加密
				var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
				let srcs = CryptoJS.enc.Utf8.parse(word);
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				});
				return encrypted.toString();
			},
         decrypt(word){
			    var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
			    var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
			    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
      },
      decryptDes(message){
var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625")
var decrypted = CryptoJS.DES.decrypt(
{
ciphertext: CryptoJS.enc.Hex.parse(message)
},
keyHex,
{
mode: CryptoJS.mode.ECB,
padding: CryptoJS.pad.Pkcs7
}
)
return decrypted.toString(CryptoJS.enc.Utf8)
}

    },
mounted(){
},
    created(){
//       let arr;
// if(sessionStorage.getItem("typeControll")=="null"){
//    arr=JSON.parse(sessionStorage.getItem("codes"))
// }else{
//   arr=JSON.parse(sessionStorage.getItem("typeControll"))

// }

// for(let i in arr){
//   this.cblxList.push({
//     label:getType(arr[i]),
//     value:arr[i]
//   })
// }
// this.cblx=arr[0]

    }
  }

</script>



// WEBPACK FOOTER //
// src/views/shangCheng/msgSelect.vue